module.exports = __webpack_public_path__ + "img/share-info.fa0bedf8.png";